import * as AWS from '../constants/AWS';
import { Dispatch } from 'redux';

export const changePassword = (
  oldPassword: string, newPassword: string,
  requestFunc: Function, fetchedFunc: Function) => {
  return (dispatch: Dispatch<void>) => {
    dispatch(requestFunc());

    const userPool = AWS.userPool();
    const cognitoUser = userPool.getCurrentUser();
    if (cognitoUser != null) {
      cognitoUser.getSession(function() { console.log('get session'); });
      cognitoUser.changePassword(oldPassword, newPassword, function(err: Error, result: any) {
        if (err) {
          dispatch(fetchedFunc(false, err));
        } else {
          dispatch(fetchedFunc(true));
        }
      });
    } else {
      dispatch(fetchedFunc(false, 'User is not signed-in'));
    }
  };
};

export const forgotPassword = (
  username: string, requestFunc: Function, fetchedFunc: Function) => {
  return (dispatch: Dispatch<void>) => {
    dispatch(requestFunc());

    let cognitoUser = AWS.cognitoUser(username);
    if (cognitoUser != null) {
      cognitoUser.forgotPassword({
        onSuccess: function(result: any) {
          dispatch(fetchedFunc(true));
        },
        onFailure: function(err: any) {
          console.log(err);
          if (err.toString().match(/Attempt limit exceeded/)) {
            dispatch(fetchedFunc(false, err));
          } else {
            dispatch(fetchedFunc(false, err));
          }
        },
      });
    } else {
      dispatch(fetchedFunc(false, 'An error is occured'));
    }
  };
};

export const confirmPassword = (
  username: string, confirmationCode: string, newPassword: string,
  requestFunc: Function, fetchedFunc: Function) => {
  return (dispatch: Dispatch<void>) => {
    dispatch(requestFunc());

    let cognitoUser = AWS.cognitoUser(username);
    if (cognitoUser != null) {
      cognitoUser.confirmPassword(confirmationCode, newPassword, {
        onSuccess: function() {
          dispatch(fetchedFunc(true));
        },
        onFailure: function(err: Error) {
          console.log(err);
          dispatch(fetchedFunc(false, err));
        },
      });
    } else {
      dispatch(fetchedFunc(false, 'An error is occured'));
    }
  };
};

export const resetStatus = (requestFunc: Function) => {
  return (dispatch: Dispatch<void>) => {
    dispatch(requestFunc());
  };
};



// WEBPACK FOOTER //
// ./src/api/Password.tsx